

















import Vue from 'vue'
// @ts-ignore
import { AgGridVue } from 'ag-grid-vue'
import { QcqOperations } from '@/types/enums'
import {
  GridOptions,
  QcqCommonGridItem,
  QcqDataDomain
} from '@/types'

interface ComponentData {
  gridData: Array<QcqCommonGridItem>
  gridOptions: GridOptions
  operation: typeof QcqOperations
  currentSelectedRowId: number
  overlayNoRowsTemplate: string
}

export default Vue.extend({
  name: 'QcqViewGrid',

  components: {
    AgGridVue
  },

  props: {
    label: String,
    onRowClickedParent: Function,
    data: {
      type: Array as () => Array<QcqCommonGridItem>
    },
    selectedJob: Number,
    selectedSpecialization: Number,
    selectedDetail: Number
  },

  computed: {},

  watch: {
    data (newVal: Array<QcqDataDomain>): void {
      if (newVal && newVal.length > 0) {
        const gridData = newVal.map((item: QcqDataDomain) => {
          return item.commonGridData
        })
        this.currentSelectedRowId = -1
        this.gridData = gridData
      } else if (newVal && newVal.length === 0) {
        this.gridData = []
        this.currentSelectedRowId = -1
      }
    }
  },

  data (): ComponentData {
    return {
      gridData: [],
      gridOptions: {
        columnDefs: [
          { headerName: this.$t('qcqQualificationPage.code'), field: 'code', width: 100 },
          { headerName: this.$t('qcqQualificationPage.description'), field: 'description' }
        ]
      },
      operation: QcqOperations,
      currentSelectedRowId: -1,
      overlayNoRowsTemplate: "<span>"+this.$t('errors.noRowsToShow')+"</span>"
    }
  },

  methods: {
    onRowDataChanged () {
      //@ts-ignore
      this.gridOptions.api.sizeColumnsToFit()
      if(this.selectedJob) {
        this.gridOptions.api.forEachNode((node: any) => {
          if(node.data.id === this.selectedJob) {
            this.currentSelectedRowId = this.selectedJob
            node.setSelected(true)
            this.$emit('onJobsClicked', node.data)
          }
        });
      } else if(this.selectedSpecialization) {
        this.gridOptions.api.forEachNode((node: any) => {
          if(node.data.id === this.selectedSpecialization) {
            this.currentSelectedRowId = this.selectedSpecialization
            node.setSelected(true)
            this.$emit('onSpecializationClicked', node.data)
          }
        });
      } else if(this.selectedDetail) {
        this.gridOptions.api.forEachNode((node: any) => {
          if(node.data.id === this.selectedDetail) {
            this.currentSelectedRowId = this.selectedDetail
            node.setSelected(true)
            this.$emit('onDetailClicked', node.data)
          }
        });
      }
    },

    onRowClicked (params: any) {
      this.onRowClickedParent(params.node.data)
      this.currentSelectedRowId = params.node.data.id
    }
  }
})
